<template>
	<div class="item" @click="chooseItem">
		<div class="img-wrap">
			<img :src="$attrs.img_url"/>
		</div>
		<i class="num" v-if="$attrs.item_num>1">x{{$attrs.item_num}}</i>
		<span :class="['choose',{'focus':focus}]" v-if="$attrs.type=='buy'"></span>
		<span
			class="name"
			v-if="$attrs.showName!==undefined
			&&$attrs.showName===true
			&&$attrs.showNameIndex==$attrs.index
			&&focus"
		>
			{{$attrs.item_name}}
		</span>
		<template v-if="$attrs.drawn&&!$attrs.modal">
			<i class="mask"></i>
			<i class="got-icon"></i>
		</template>
	</div>
</template>
<script>
export default{
	name: "Item",
	data(){
		return{}
	},
	inheritAttrs: false,
	computed:{
		focus(){
			return (this.$attrs.wantBuy&&this.$attrs.wantBuy.pk==this.$attrs.pk)
					||(this.$attrs.type=='draw'&&!this.$attrs.drawn)
		}
	},
	methods: {
		chooseItem(){
			this.$listeners.chooseItem()
		}
	}
}
</script>
<style lang="scss" scoped>
.item{
	position: relative;
	background-size: 100% 100%;
	@include res-size(
		$width: 128px,
		$height: 128px
	)
	.img-wrap{
		width: 100%;
		height: 100%;
		@include flexcc
		img{
			width: auto;
			height: auto;
			max-width: 85%;
			max-height: 85%;
		}
	}
	.num{
		position: absolute;
		@include res-size(
			$left: 15px,
			$bottom: 10px,
			$font-size: 20x
		)
	}
	.got-icon,.mask{
		position: absolute;
		background-size: cover;
		@include res-size(
			$width: 73px,
			$height: 72px,
		)
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	.mask{
		background-color: #000;
		opacity: .3;
		@include res-size(
			$width: 120px,
			$height: 120px,
			$border-radius: 20px
		)
	}
	.name{
		position: absolute;
		background-size: 100% 100%;
		text-align: center;
		z-index: 2;
		@include flexcc;
		@include res-size(
			$padding-left: 5px,
			$padding-right: 6px,
			$font-size: 24px,
			$width: 173px,
			$min-height: 37,
			$padding-top: 5px,
			$left: 110px,
			$top: 40px
		)
	}
	.choose{
		position: absolute;
		border: 1px solid #269c9f;
		background-color: #0a2129;
		@include res-size(
			$width: 20px,
			$height: 20px,
			$right: 13px,
			$bottom: 10px
		)
		&::after{
			position: absolute;
			background-size: cover;
			content: "";
			visibility: hidden;
			@include res-size(
				$width: 34px,
				$height: 34px,
				$left: -7px,
				$bottom: -5px
			)
		}
	}
	.focus::after{
		visibility: visible;
	}
}
.draw-item .num,.history-item .num{
	left: auto;
	@include res-size(
		$right: 15px
	)
}
.draw-item .name{
	left: auto;
	@include res-size(
		$right: 50px
	)
}

.got-icon{
	@include bright
}
</style>


// WEBPACK FOOTER //
// src/components/item/index.vue